import { AppTopBar } from '../AppTopBar';

export function InvestorTopBar() {
  return (
    <AppTopBar
      homeTo="/investor"
      homeAriaLabel="UMB eVault — Investor home"
    />
  );
}
